$('body').on('click', 'button', function () {
    if($(this).find('.indicator-label')) {
        $(this).attr('data-kt-indicator', 'on');
    }
});
